import styled from 'styled-components';

interface StyledFlexContainerProps {
  $flexWrap?: boolean;
  $isColumn?: boolean;
}
interface StyledFlexItemProps {
  $isSmall?: boolean;
}

const StyledFlexContainer = styled.div<StyledFlexContainerProps>`
  display: flex;
  justify-content: space-between;
  flex-wrap: ${(props) => (props.$flexWrap ? 'wrap' : 'inherit')};
  min-height: auto;
  background-color: unset;
  border: 1px solid transparent;
  flex-direction: ${(props) => (props.$isColumn ? 'column' : 'row')};
  svg path {
    fill: ${(props) => props.theme.colors.white};
  }
`;

const StyledFlexItem = styled.div<StyledFlexItemProps>`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.85rem;
  > div {
    align-self: center;
  }

  ${(props) => props.$isSmall
    && `
    font-size: ${props.theme.typography.fontSizeSmall};
  `}
`;

export { StyledFlexContainer, StyledFlexItem };
